import { Component } from 'opus-angular-seed-core';
import $ from 'jquery';

@Component({
    bindings: {
        scormSubmission: '=',
        viewOnly: '='
    },
    template: `
        <div class="scorm-container">
            <div class="topbar">
                <div class="close-icon" ng-click="vm.submit()" ng-if="!vm.loading" ></div>
            </div>
            <loader-icon ng-if="vm.loading"></loader-icon>
            <iframe
                id="scorm"
                class="scorm-player-iframe"
                src="{{ vm.getIframeUrl() }}"
                sandbox="allow-scripts allow-same-origin allow-modals allow-popups allow-popups-to-escape-sandbox allow-downloads"
            >
            </iframe>
        </div>
    `
})
export default class {
    constructor (
        ScormSubmissionResource,
        ModalService,
        $translate,
        $state,
        $scope,
        $sce,
        $window,
        CompanyService,
        TokenService,
        OccurrenceResource,
        toastr,
        $interval,
        COURSE_PROGRESS_STATUS_TYPE_ENUM,
        COURSE_TRAINING_MATERIAL_TYPE_ENUM
    ) {
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.$interval = $interval;
        this.ScormSubmissionResource = ScormSubmissionResource;
        this.OccurrenceResource = OccurrenceResource;
        this.ModalService = ModalService;
        this.$state = $state;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$sce = $sce;
        this.$window = $window;
        this.toastr = toastr;
        this.form = this.scormSubmission;

        $('#loading-bar').hide();
        this.loading = false;
        this.progress = {};
        this.scormIframe = null;
        this.CompanyService = CompanyService;
        this.TokenService = TokenService;
        this.inFrame = self !== top;

        this.actor = encodeURIComponent(
            JSON.stringify({
                name: ['Scorm submitter'],
                objectType: 'Agent'
            })
        );

        this.url =
            `${SEED_CORE.ENV.API_URL}scorm/${this.scormSubmission.guid}${this.scormSubmission.scorm.entrypoint}` +
            `?actor=${this.actor}&endpoint=${SEED_CORE.ENV.API_URL}scorm/scorm-submission/tincan-statements/`;
        if (!this.viewOnly) {
            this.url += `${this.scormSubmission.guid}/`;
            if (this.scormSubmission.scorm.type === 'ISPRING') {
                const params = JSON.parse(this.scormSubmission.scorm.params);
                if (params.activity_id) {
                    this.url +=
                        `&activity_id=${params.activity_id}` + '&auth=Basic';
                }
            }
        }
        this.state = false;
        // constant update state
        setInterval(() => {
            this.updateState();
        }, '3000');
    }

    updateState () {
        this.ScormSubmissionResource.get({
            guid: this.scormSubmission.guid
        }).$promise.then((data) => {
            this.state = data.state;
        });
    }

    $onInit () {
        this.deadlineStopped = this.viewOnly === '1'
            || !this.scormSubmission
            || !this.scormSubmission.occurrenceTrainingId;

        this.startDeadlineCheck();

        if (this.viewOnly !== '1') {
            window.addEventListener('message', (event) => {
                if (event.data.method) {
                    if (event.data.method === 'progressFromRuntime') {
                        this.processProgressFromRuntime(event.data.progress);
                    }
                    if (event.data.method === 'progressFromWrapper') {
                        this.processProgressFromWrapper(event.data.progress);
                    }
                }
            });
        }
        this.scormIframe = document.getElementById('scorm');
        this.scormIframe.onload = () => {
            this.scormIframe.contentWindow.postMessage(
                {
                    url: this.url,
                    progressJson: this.scormSubmission.progressJson,
                    start: true
                },
                '*'
            );
        };
    }

    submit () {
        if (this.viewOnly) {
            this.closeScorm();
            return;
        }

        if (this.loading) {
            return;
        }

        this.loading = true;
        new Promise((resolve) => {
            setTimeout(() => {
                this.askProgress();
                resolve();
            }, 3000);
        }).finally(() => {
            // this timeout needed to be sure that we received progress from iframe
            setTimeout(() => {
                this.loading = false;
                this.closeScorm();
            }, 500);
        });
    }

    closeScorm () {
        if (this.inFrame) {
            this.closeModalWindow();
        }
        else {
            window.close();
        }
    }

    processProgressFromWrapper (progress) {
        this.form.type = 'WRAPPER';
        this.sendProgress(progress, false);
    }

    processProgressFromRuntime (progress) {
        this.form.type = 'RUNTIME';
        // if progress is empty check from the updated object. In case of storyline type files
        // we can't get progress without fetching it from db.
        if (Object.keys(progress).length === 0) {
            this.ScormSubmissionResource.get({
                guid: this.scormSubmission.guid
            }).$promise.then((data) => {
                progress = JSON.parse(data.progressJson);
                this.sendProgress(progress, true);
            });
        }
        else {
            this.sendProgress(progress, true);
        }
    }

    sendProgress (progress, close = false) {
        this.form.progressJson = progress;
        this.ScormSubmissionResource.update(
            { guid: this.scormSubmission.guid },
            this.form
        ).$promise.finally(() => {
            if (close === true) {
                this.closeScorm();
            }
        });
    }

    closeModalWindow () {
        parent.postMessage('action:closeMaterialDialog', '*');
    }

    getIframeUrl () {
        return this.$sce.trustAsResourceUrl(
            `${SEED_CORE.ENV.API_URL}scorm/index.html`
        );
    }

    askProgress () {
        this.scormIframe.contentWindow.postMessage(
            { method: 'progressFromRuntime' },
            '*'
        );
    }

    handleOverdueDeadline () {
        return this.OccurrenceResource.handleOverdueDeadline(
            {},
            {
                guid: this.scormSubmission.guid,
                materialType: this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_SCORM,
                occurrenceTrainingId: this.scormSubmission.occurrenceTrainingId
            }
        ).$promise.then((response) => response.status === this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.NOT_PASSED);
    }

    startDeadlineCheck () {
        if (this.deadlineStopped) {
            return;
        }

        this.deadlineCheckInterval = this.$interval(() => {
            this.handleOverdueDeadline().then((isNotPassed) => {
                if (isNotPassed) {
                    this.stopDeadlineCheck();
                    this.toastr.error(
                        this.$translate.instant('materials.Failed to pass the course before the deadline')
                    );
                    setTimeout(() => {
                        this.closeScorm();
                    }, 2000);
                }
            });
        }, 60000);
    }

    stopDeadlineCheck () {
        if (this.deadlineCheckInterval) {
            this.$interval.cancel(this.deadlineCheckInterval);
            this.deadlineCheckInterval = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/scorm/player/scorm/index.js